import styled from 'styled-components';
import Lottie from 'lottie-react';
import {
	Divider,
	Button,
	Input,
	Card,
	Progress,
	Select,
	Badge,
	Tag,
} from 'antd';

const { TextArea } = Input;

export const XTitleHeader = styled.h1`
	margin: 0px;
	width: 100%;
	position: relative;
	font-style: normal;
	font-weight: 600;
	font-size: 24px;
	line-height: 48px;
	color: #353b3e;
	margin-bottom: 16px;
`;
export const XDivider = styled(Divider)`
	width: 100%;
	position: relative;
	margin: 24px 0;
`;
export const XInputTextArea = styled.textarea`
	width: 100%;
	position: relative;
	min-height: 200px;
	padding: 12px;
	border: 1px solid #d9d9d9;
	border-radius: 4px;
	resize: vertical;
	font-family: inherit;

	&:focus {
		outline: none;
		border-color: ${({ theme }) => theme.CQColors.secondaryColor};
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
	}
`;
export const ActionButtonGroup = styled.div`
	display: flex;
	gap: 8px;
	margin-top: 16px;
	flex-wrap: wrap;
`;
export const ActionButton = styled(Button)`
	display: flex;
	align-items: center;
	gap: 4px;

	&.ant-btn {
		height: 32px;
		padding: 4px 12px;
		border-radius: 4px;
		font-size: 14px;

		&:disabled {
			cursor: not-allowed;
			opacity: 0.5;
		}

		.anticon {
			font-size: 16px;
		}
	}

	@media (max-width: 576px) {
		flex: 1;
		justify-content: center;
	}
`;
export const XDeIdentifyBtn = styled(Button)`
	margin-left: 0px !important;
	background: ${({ theme }) => theme.CQColors.gradientBg} !important;
	/* box-shadow: 0px 156px 94px rgba(0, 114, 153, 0.05),
		0px 69px 69px rgba(0, 114, 153, 0.1),
		0px 17px 38px rgba(0, 114, 153, 0.1) !important; */
	/* filter: drop-shadow(0px 15px 20px rgba(0, 114, 153, 0.4)) !important; */
	/* backdrop-filter: blur(9px); */
	font-family: ${({ theme }) => theme.CQColors.fontInter} !important;
	border-color: ${({ theme }) => theme.CQColors.white} !important;
	box-shadow: none !important;
	border-radius: 30px !important;
	font-weight: 500 !important;
	font-size: 18px !important;
	line-height: 20px !important;
	letter-spacing: -0.02em;
	color: ${({ theme }) => theme.CQColors.white};
	height: auto !important;
	padding: 10px 30px !important;
	&:hover,
	&:active {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border-color: ${({ theme }) => theme.CQColors.white} !important;
	}
`;

/*******************/
export const XThemShieldDesktop = styled.section`
	width: 100%;
	position: relative;
`;
export const XLottieShieldMaxx = styled(Lottie)`
	position: relative;
	background: transparent;
	width: 50%;
	margin: 0px auto;
	&.fullView {
		width: 50%;
	}
	@media only screen and (max-width: 768.99px) {
		width: 100%;
	}
`;
export const XShieldMaxxTitle = styled.h1`
	font-weight: 600;
	font-size: 24px;
	line-height: 16px;
	color: ${({ theme }) => theme.CQColors.primaryColor};
`;
export const ParaShieldMaxx = styled.p`
	margin: 0px;
	font-weight: 500;
	font-size: 16px;
	line-height: 24px;
	text-align: center;
	color: ${({ theme }) => theme.CQColors.primaryColor};
`;
export const XTextAreaShieldMaxx = styled(TextArea)`
	background: ${({ theme }) => theme.CQColors.bodyBg};
	color: ${({ theme }) => theme.CQColors.primaryColor};
	border: 1px solid rgba(0, 0, 0, 0.1);
	backdrop-filter: blur(21px);
	padding-bottom: 50px !important;
	resize: none !important;
	&:hover,
	&:focus,
	&:active,
	&:focus-visible {
		border-color: ${({ theme }) => theme.CQColors.secondaryColor}!important;
		box-shadow: none !important;
	}
	&.smallChatBox {
		padding-bottom: 45px !important;
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
	}
	&:disabled {
		background: #f9f9f9 !important;
	}
`;
export const XTextAreaShieldMaxxBTN = styled.div`
	position: absolute;
	width: calc(100% - 40px);
	background: ${({ theme }) => theme.CQColors.bodyBg}!important;
	padding: 5px 0px;
	bottom: 0.5px;
	left: 20px;
	right: 20px;
	font-weight: 400;
	font-size: 12px;
	line-height: 18px;
	color: ${({ theme }) => theme.CQColors.primaryColor};
	&.smallChatBox {
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
		bottom: 11px !important;
		padding: 2px;
	}
	.iconButtonLeft {
		float: left;
		margin-top: 10px;
		cursor: pointer;
	}
	.iconButtonRight {
		float: right;
		cursor: pointer;
	}
	&.mainUpload {
		.ant-upload-list {
			position: absolute;
			top: -270%;
			left: 0px;
			right: 0px;
			max-width: 200px;
			background: ${({ theme }) => theme.CQColors.bodyBg};
			border-radius: 16px;
			margin-top: 7px;
			.ant-upload-list-item-container,
			.ant-upload-list-item {
				margin: 0px !important;
			}
			.ant-upload-list-item {
				background: ${({ theme }) => theme.CQColors.white};
			}
		}
	}
	&.innerUpload {
		.ant-upload-list {
			position: absolute;
			top: -190%;
			left: 0px;
			right: 0px;
			width: 100%;
			background: ${({ theme }) => theme.CQColors.bodyBg};
			border-radius: 16px;
			margin-top: 2px;
			.ant-upload-list-item-container,
			.ant-upload-list-item {
				margin: 0px !important;
			}
			.ant-upload-list-item {
				background: ${({ theme }) => theme.CQColors.white};
				padding: 0px 15px 0px 0px;
				height: auto;
			}
		}
	}
`;
export const ParaShieldLeftScrollWrapper = styled.div`
	width: 100%;
	position: relative;
	min-height: calc(100vh - 110px);
	display: block;
	background: transparent;
	.header {
		position: absolute;
		z-index: 1;
		top: 0;
		left: 15px;
		right: 15px;
		background: ${({ theme }) => theme.CQColors.white};
		border-radius: 16px;
		padding: 15px;
		em {
			width: 30px;
			height: 30px;
			border-radius: 50%;
			display: block;
			background: ${({ theme }) => theme.CQColors.gradientBg};
		}
		&.leftHeaderData {
			width: calc(100% - 30px);
			display: block;
			background: ${({ theme }) => theme.CQColors.white} !important;
			font-weight: 500;
			font-size: 14px;
			line-height: 60px;
			color: ${({ theme }) => theme.CQColors.primaryColor};
			padding: 0px 15px 0px 0px;
			border-bottom: 1px solid #f0f0f0;
			border-radius: 16px 16px 0px 0px;
			left: 15px;
			right: 15px;
			.leftTitleAnimation {
				width: 60px;
				height: 60px;
				float: left;
			}
		}
	}
	.footer {
		position: absolute;
		z-index: 1;
		left: 10px;
		right: 10px;
		background: ${({ theme }) => theme.CQColors.white};
		border-radius: 16px;
		bottom: 0px;
		padding: 10px;
	}
	.leftScrollData {
		width: 100%;
		position: relative;
		height: calc(100vh - 110px);
		min-height: 100%;
		overflow-y: auto;
		padding: 60px 20px 160px 20px !important;
		background: ${({ theme }) => theme.CQColors.white};
		border: 1px solid #f0f0f0;
		border-radius: 16px;
		&::-webkit-scrollbar {
			display: none;
		}

		scrollbar-width: none;
		&.RightScrollData {
			padding: 80px 20px !important;
			overflow: hidden;
			&.noPaddingbottom {
				padding-bottom: 10px !important;
			}
			.rightScrollDataTitle {
				font-weight: 500;
				font-size: 16px;
				line-height: 24px;
				color: ${({ theme }) => theme.CQColors.primaryColor};
				span {
					font-weight: 400;
					color: ${({ theme }) => theme.CQColors.primaryColor};
				}
			}
		}
		p {
			margin: 0px;
			font-weight: 400;
			font-size: 12px;
			line-height: 22px;
			color: ${({ theme }) => theme.CQColors.primaryColor};
		}
	}
`;
export const XShieldRightScrollCard = styled(Card)`
	width: 100%;
	position: relative;
	height: 100%;
	overflow-y: auto;
	p {
		margin: 0px;
		font-weight: 400;
		font-size: 14px;
		line-height: 30px;
		color: ${({ theme }) => theme.CQColors.primaryColor};
	}
	&.noCard {
		border: none;
		box-shadow: none;
		min-height: 100%;
		.ant-card-body {
			padding: 0px;
		}
	}
	&.noPaddingbottom {
		padding-bottom: 10px !important;
	}
	&::-webkit-scrollbar {
		display: none;
	}
	scrollbar-width: none;
`;
export const XProgressShieldRight = styled(Progress)``;

export const XThemeShieldLoader = styled.div`
	position: relative;
	width: calc(100% - 48px);
	margin-top: 10%;
	height: 5px;
	border-radius: 10px;
	overflow: hidden;
	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0px;
		right: 0px;
		width: 100%;
		height: 100%;
		animation: shimmer 3s infinite;
		z-index: 99;
	}
	&.loader1 {
		&::before {
			background: ${({ theme }) => theme.CQColors.gradientBg};
		}
	}
	@keyframes shimmer {
		0% {
			transform: translateX(-100%);
		}
		100% {
			transform: translateX(100%);
		}
	}
`;
export const XShieldSuggestionBTN = styled(Button)`
	background: ${({ theme }) => theme.CQColors.bodyBg};
	color: ${({ theme }) => theme.CQColors.themeColor6};
	border-color: ${({ theme }) => theme.CQColors.themeColor4};
	border-radius: 10px;
	font-weight: 400;
	font-size: 10px;
	line-height: 18px;
	svg {
		opacity: 0.2;
		font-size: 16px !important;
	}
	&:hover {
		background: ${({ theme }) => theme.CQColors.gradientBg} !important;
		color: ${({ theme }) => theme.CQColors.white} !important;
		border-color: ${({ theme }) => theme.CQColors.white} !important;
		svg,
		img {
			opacity: 1 !important;
			filter: brightness(0) saturate(100%) invert(100%) sepia(0%)
				saturate(7493%) hue-rotate(237deg) brightness(107%)
				contrast(102%) !important;
		}
	}
`;

export const XShieldSpiderCard = styled.div`
	width: 100%;
	position: relative;
	overflow-x: scroll;
	white-space: nowrap;
	.spiderData {
		display: inline-block;
		min-width: calc(33.33% - 10px);
		margin-right: 10px;
		background: rgba(0, 119, 206, 0.05);
		border: 1px solid rgba(0, 119, 206, 0.1);
		border-radius: 10px;
		&:last-child {
			width: 33.33%;
			margin-right: 0px;
		}
		&:nth-child(2n) {
			background: rgba(141, 75, 225, 0.05);
			border: 1px solid rgba(141, 75, 225, 0.1);
		}

		span {
			background: ${({ theme }) => theme.CQColors.white};
			padding: 5px 10px;
			border-radius: 35px;
			color: ${({ theme }) => theme.CQColors.secondaryColor};
			min-width: 60px;
			text-align: center;
		}
		ul {
			margin: 0px;
			padding: 0px;
			li {
				list-style: none;
				padding: 10px 15px;
				border-bottom: 1px solid
					${({ theme }) => theme.CQColors.borderColor};
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-weight: 500;
				font-size: 12px;
				line-height: 16px;
				color: ${({ theme }) => theme.CQColors.primaryColor};
				&:last-child {
					border-bottom: none;
				}
				.spiderDataTitle {
					span {
						margin-right: 5px;
						color: ${({ theme }) => theme.CQColors.secondaryColor};
						font-weight: 600;
						background: transparent;
						padding: 0px;
					}
				}
			}
		}
	}

	&::-webkit-scrollbar {
		display: none;
	}
	scrollbar-width: none;
`;

// Add new spider chart styling
export const XSpiderChartContainer = styled.div`
	width: 100%;
	height: 300px;
	position: relative;
	background: ${({ theme }) => theme.CQColors.bodyBg};
	border-radius: 12px;
	padding: 20px;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

	canvas {
		max-height: 280px !important;
	}

	@media (max-width: 768px) {
		height: 250px;
		padding: 15px;

		canvas {
			max-height: 230px !important;
		}
	}
`;

export const XSpiderChartTitle = styled.h3`
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	color: ${({ theme }) => theme.CQColors.primaryColor};
	margin-bottom: 15px;
	text-align: center;
`;

export const XSpiderChartLegend = styled.div`
	display: flex;
	justify-content: center;
	gap: 20px;
	margin-top: 15px;
	flex-wrap: wrap;

	.legend-item {
		display: flex;
		align-items: center;
		gap: 8px;
		font-size: 12px;
		font-weight: 500;

		.legend-color {
			width: 12px;
			height: 12px;
			border-radius: 50%;
			border: 2px solid #fff;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
		}

		.legend-text {
			color: ${({ theme }) => theme.CQColors.primaryColor};
		}
	}
`;

export const XChatTagSpider = styled(Tag)`
	position: relative;
	font-size: 14px;
	line-height: 36px;
	margin-right: 0px !important;
	.payerColor {
		width: 16px;
		height: 16px;
		float: left;
		margin-top: 10px;
		border-radius: 50%;
		background: ${({ theme }) => theme.CQColors.secondaryColor};
		margin-right: 10px;
	}
	.ant-tag-close-icon {
		margin-left: 15px;
		height: 36px;
		svg {
			color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
			font-size: 14px !important;
		}
	}
	/* .ant-select-selector {
		background: ${({ theme }) => theme.CQColors.bodyBg} !important;
		border: 1px solid rgba(0, 0, 0, 0.1) !important;
		border-radius: 8px !important;
		height: 40px !important;
		display: flex !important;
		align-items: center !important;
		padding: 0 12px !important;
	}

	.ant-select-selection-item {
		color: ${({ theme }) => theme.CQColors.primaryColor} !important;
		font-weight: 500 !important;
		font-size: 14px !important;
		display: flex !important;
		align-items: center !important;
		gap: 8px !important;
	}

	&:hover .ant-select-selector {
		border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
	}

	&.ant-select-focused .ant-select-selector {
		border-color: ${({ theme }) => theme.CQColors.secondaryColor} !important;
		box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2) !important;
	}

	.ant-select-dropdown {
		.ant-select-item {
			padding: 8px 12px !important;

			&:hover {
				background-color: rgba(24, 144, 255, 0.1) !important;
			}

			&.ant-select-item-option-selected {
				background-color: rgba(24, 144, 255, 0.2) !important;
			}
		}
	} */
`;

export const XStatusBadge = styled(Badge)`
	.ant-badge-dot {
		width: 8px !important;
		height: 8px !important;
		border-radius: 50% !important;
	}
`;

export const XChartControlsContainer = styled.div`
	width: 100%;
	position: relative;
	overflow-x: scroll;
	white-space: nowrap;
	&::-webkit-scrollbar {
		display: none;
	}
	scrollbar-width: none;
	.dropdownList {
		display: inline-block;
		min-width: calc(33.33% - 40px);
		margin: 5px 0px 10px 0px;
		&:last-child {
			width: 33.33%;
			margin-right: 0px;
		}
		&.noWidth {
			min-width: auto;
			margin-right: 0px !important;
			&:last-child {
				width: auto !important;
			}
		}
	}
	span.vsText {
		padding: 0px 10px;
	}
	@media (max-width: 768px) {
		gap: 10px;

		.ant-select {
			width: 150px !important;
		}
	}
`;
